import axios from "axios";

export const getUsers = (user_id, updateValueHook=null) => {
    /* 
        params:
            user_id: int;
                - user object id
            updateValueHook: hook function to update a value from parent component
    */
   const token = localStorage.getItem("access_token");
   let url = process.env.REACT_APP_API_BASE_URL;
   user_id === null ? url = url + '/api/users/' : url = url + `/api/users/${user_id}`

   axios
   .get(url,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
   )
   .then((response) => {
        if (response.status === 200) {
            if (updateValueHook) {
                updateValueHook(response.data);
            } else {
                return;
            }
            
        }
   })
   .catch((error) => {
        if (error.response) {
            console.error("Response error:", error.response.data);
        } else {
            console.error("Error:", error.message);
        }
    });
}